import { useEffect, useState } from 'react';
import http from '../../utils/http-common';
const GlobalLoader = () => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const reqInterceptor = http.interceptors.request.use(
      function (config) {
        setLoading(true);
        return config;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );
    const resInterceptor = http.interceptors.response.use(
      function (response) {
        setLoading(false);
        return response;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );
    return () => {
      http.interceptors.request.eject(reqInterceptor);
      http.interceptors.response.eject(resInterceptor);
    };
  }, []);
  return (
    <div>
      {loading && (
        <div className="fixed w-full h-full left-0 top-0 z-[5] bg-[rgba(255,255,255,.7)]"></div>
      )}
    </div>
  );
};

export default GlobalLoader;
